import React from 'react';
import PropTypes from 'prop-types';

import { Multiselect } from 'spicecomponents';

const MultipleSurveys = (props) => {
  const onChange = (selectedOptions) => {
    if (selectedOptions.length > 0) {
      props.onChange(selectedOptions.map((option) => option.value));
    } else {
      props.onChange(null);
    }
  };

  return (
    <Multiselect options={getOptions(props.controlList)} value={getValue(props.cdf)} onChange={onChange} />
  );
};

const getOptions = (controlList) => (
  controlList.Options.map((survey) => ({
    value: survey,
  }))
);

const getValue = (cdf) => (
  cdf.SurveyList || []
);

MultipleSurveys.propTypes = {
  controlList: PropTypes.object,
  cdf: PropTypes.object,
  onChange: PropTypes.func,
};

export default MultipleSurveys;



// WEBPACK FOOTER //
// ./app/components/FormControls/SurveyList/MultipleSurveys.js